import { useSelector } from 'react-redux';
import { useGetProductCategoriesQuery } from '../api/productCategory/productCategoryApiSlice';
import { tenantSelector } from '../selector/authenticationSelector';
import { isSelfServiceTenant } from '../common/tenantStore';

/**
 * The product categories of the tenant ON SCREEN. Every caller reads them
 * through this hook, not through `useGetProductCategoriesQuery` directly.
 *
 * Categories exist for operational tenants only: for a legacy `X-Tenant` the
 * endpoint answers 409 (`scopedPrismaOrRespond`, new-backend/admin
 * `productCategoryController.ts`). So the read is skipped unless the SELECTED
 * tenant (`tenantSelector`) is operational. That is the same value that stamps
 * the header, so the skip and the 409 cannot disagree. This matters
 * on a hard load, for a master viewing a legacy tenant, and on surfaces that
 * stay mounted for legacy tenants. A skipped read reports neither loading nor
 * error and has no data, so callers fall back exactly as they do while it
 * loads.
 */
export const useTenantProductCategoriesQuery = (
    args: { includeArchived?: boolean } | void = undefined,
    options: { skip?: boolean } = {},
) => {
    const selfService = isSelfServiceTenant(useSelector(tenantSelector));
    return useGetProductCategoriesQuery(args, { skip: !!options.skip || !selfService });
};
